/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module ApplicationProfileModule
 */

import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';
import { RateProfile } from 'object-types';
import { IRateProfile } from 'generated-types';
import { RateLimiterActionConfigItem } from 'ng/modules/message-items/factories';
import { RateLimiterConfigItem } from 'ajs/modules/scripts/factories/data-script-set/rate-limiter.config-item.factory';

type TRateProfilePartial = Omit<IRateProfile, 'action' | 'rate_limiter'>;

export interface IRateProfileConfig extends TRateProfilePartial{
    action?: RateLimiterActionConfigItem;
    rate_limiter?: RateLimiterConfigItem;
}

/**
 * @description Rate Profile ConfigItem.
 * @author Nisar Nadaf, Umesh Chovatiya.
 */
export class RateProfileConfigItem extends MessageItem<IRateProfileConfig> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: RateProfile,
            ...args,
        };

        super(extendedArgs);
    }

    /** @override */
    protected requiredFields(): string[] {
        return [
            'rate_limiter',
        ];
    }
}
